import { isValidElement } from 'react';
export function isCollectionElement(node) {
    return (isValidElement(node) &&
        typeof node.type === 'function' &&
        typeof node.type.getCollectionNode === 'function');
}
